import useWidget from '../../../hooks/useWidget.js';
const useSearchResultsConfig = () => {
    const { config } = useWidget();
    return config;
};
export default useSearchResultsConfig;
